import {IItem} from './types';

export const DIVIDER: IItem = {
  label: '__divider__',
  value: '__divider__',
  selectable: false,
};

export const LOADING: IItem = {
  label: '__loading__',
  value: ''
}
